import * as React from 'react';
import { styled } from 'styled-components';

const ImageContainer = ({ imageSrc, imageSize }: Props) => {
	return (
		<StyledImgContainer>
			{imageSrc && <StyledImg src={imageSrc} alt="modal icon" $imageSize={imageSize} />}
		</StyledImgContainer>
	);
};

interface Props {
	imageSrc: string | null;
	imageSize?: number;
}

export default ImageContainer;

const StyledImg = styled.img<{ $imageSize?: number }>`
	width: ${(props) => props.$imageSize ?? 100}px;
	height: ${(props) => props.$imageSize ?? 100}px;
	object-fit: contain;
`;

export const StyledImgContainer = styled.div`
	margin: 0 auto 32px auto;
	text-align: center;
`;
